import React from "react";
import { useRoutes } from "react-router-dom";
import { ProtectedRoute } from "./ProtectedRoute";
import { v2RouteObject } from "../v2/router/v2-routes";

import { routesConfig } from "./routesConfig";

const wrapProtectedRoutes = (routes) => {
  return routes.map(({ path, element, protected: isProtected, children }) => ({
    path,
    element: isProtected ? (
      <ProtectedRoute>{React.createElement(element)}</ProtectedRoute>
    ) : (
      React.createElement(element)
    ),
    children: children ? wrapProtectedRoutes(children) : undefined, // Recursively apply to children
  }));
};

// Create a Routes component to render routes dynamically
// v2 routes are added alongside v1 routes — they coexist under /v2/*
export const Routes = () => {
  const v1Routes = wrapProtectedRoutes(routesConfig);
  return useRoutes([...v1Routes, v2RouteObject]);
};
